import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';


import React from 'react'
HighchartsMore(Highcharts);

function Linechart() {
   const options = {
  chart: {
    type: "spline",
    backgroundColor: "#191C23",
    borderRadius: '8px'
  },
  title: {
    text: "Revenue",
    align: 'flex-start', 
    style: {
      
      color: '#FCFDFF', // set the color of the title
      textOutline: 'none', // remove the text outline of the title

    },
  },
  xAxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May"]
  },
  yAxis: {
    title: {
      text: "Values"
    }
  },
  series: [
    {
      name: "Series 1",
      data: [4, 2, 3, 9, 5],
      lineWidth: 3,
      color: "#6964FF",
      states: {
        hover: {
          lineWidthPlus: 0,
        }
      },
      marker: {
        lineWidth: 1,
        lineColor: "#4572A7"
      },
      threshold: null,
      linecap: 'round',
      linejoin: 'round'
    },
    {
      name: "Series 2",
      data: [2, 4, 9, 2, 10],
      lineWidth: 3,
      color: "#6964FF",
      states: {
        hover: {
          lineWidthPlus: 0,
        }
      },
      marker: {
        lineWidth: 1,
        lineColor: "#AA4643"
      },
      threshold: null,
      linecap: 'round',
      linejoin: 'round'
    }
  ]
};

      
  return (
    <div> <HighchartsReact highcharts={Highcharts} options={options} /></div>
  )
}

export default Linechart;